import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';
import HudVoucherService from '../../services/hudVoucherService';

const useDownloadHUD52670Mutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  selectedPropertyName,
  voucherYearMonth,
}) => {
  return useMutation(
    async () => {
      const service = new HudVoucherService();
      const fileName = generateStandardFilename({
        type: 'HUD-52670',
        descriptor: `${voucherYearMonth || 'voucher'} ${
          selectedPropertyName || 'Property'
        }`,
        extension: 'pdf',
      });
      return service.downloadHud52670(
        organizationId,
        propertyId,
        hudVoucherId,
        fileName,
      );
    },
    {
      onError: (error) => {
        const msg =
          typeof error === 'string'
            ? error
            : error?.error ||
              error?.networkError ||
              error?.message ||
              'Failed to download HUD 52670.';

        toastr.error('Error', msg);
      },
    },
  );
};

export default useDownloadHUD52670Mutation;
